import { 
  getKeys,
  getLabels, 
  getOptionsLabel, 
  getUnitMap 
} from '@@/utils/getFields'
import { 
  isShowPcbParams, 
  validatePcbQuote 
} from '@@/utils/pcbQuoteFormat'

const FIELDS = [
  {
    title: 'PCB文件',
    list: [
      {
        key: 'pcbfile',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return (params.pcbfile || '').split('/').pop()
        }
      }
    ]
  },
  {
    title: '基本信息',
    list: [
      {
        key: 'board_type',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'hybrid_type',
        boardTypes: ['ROGERS'],
      },
      {
        key: 'aluminium_board_type',
        boardTypes: ['ALU'],
      },
      {
        key: 'copper_board_type',
        boardTypes: ['COPPER'],
      },
      {
        key: 'blayer',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return `${params.blayer || '--'} 层`
        }
      },
      {
        key: 'blind',
        boardTypes: ['FR-4'],
      },
      {
        key: 'board',
        boardTypes: ['FR-4', 'ALU'],
        format: (params) => {
          return params.view_board || '--'
        }
      },
      {
        key: 'board_model',
        boardTypes: ['ROGERS'],
      },
      {
        key: 'board_tg',
        boardTypes: ['COPPER'],
      },
      {
        key: 'pbnum',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.pbnum || '--'
        }
      },
      {
        key: 'units',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'delivery_sub_units',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F'],
      },
      {
        key: 'length',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return `${params.length || '--'}x${params.width || '--'} cm`
        }
      },
      {
        key: 'layout',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return `${params.layoutx || '--'}x${params.layouty || '--'} Pcs`
        }
      },
      {
        key: 'bcount',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.bcount || '--'
        }
      },
      {
        key: 'sidewidth',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          if (params.sidedirection === '无') return '无'
          if (params.dfm_sets) {
            return `上: ${params.side_width_top}, 下: ${params.side_width_bot}, 左: ${params.side_width_left}, 右: ${params.side_width_right}`
          }
          return `${getOptionsLabel('FR-4', 'sidewidth', params.sidedirection)}，${params.sidewidth || '--'} mm`
        }
      },
    ]
  },
  {
    title: '工艺信息',
    list: [
      {
        key: 'material',
        boardTypes: ['FPC'],
      },
      {
        key: 'pi_thickness',
        boardTypes: ['FPC'],
      },
      {
        key: 'bheight',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return `${params.bheight || '--'} mm`
        }
      },
      {
        key: 'copper',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'insidecopper',
        boardTypes: ['FR-4', 'ROGERS', 'COPPER', 'FPC'],
      },
      {
        key: 'copper_structure',
        boardTypes: ['COPPER'],
      },
      {
        key: 'heat_factor',
        boardTypes: ['ALU', 'COPPER'],
      },
      {
        key: 'withstand_value',
        boardTypes: ['ALU'],
      },
      {
        key: 'lineweight',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'circuit_patterning_process',
        boardTypes: ['CEM-1', 'CEM-3', 'FR-1', '22F'],
      },
      {
        key: 'vias',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'color',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'charcolor',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'cover',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'FPC'],
      },
      {
        key: 'via_in_pad',
        boardTypes: ['FR-4', 'ROGERS'],
      },
      {
        key: 'spray',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'cjh',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'FPC'],
      },
      {
        key: 'electrogilding_thickness',
        boardTypes: ['FPC'],
      },
      {
        key: 'forming_method',
        boardTypes: ['ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F'],
      },
      {
        key: 'forming_type',
        boardTypes: ['FPC'],
      },
      {
        key: 'reinforce',
        boardTypes: ['FPC'],
      },
      {
        key: 'reinforce_type',
        boardTypes: ['FPC'],
        format: (params) => {
          // 补强类型
          const reinforceType = { steel: '钢片', aluminium: '铝片', fr4: 'FR-4', fingerpi: '手指位PI', otherpi: '其他位置PI' }

          return Object.keys(reinforceType).reduce((prev, cur) => {
            // 勾选的补强类型
            const isCheck = params[`reinforce_${cur}`] == 1
            // 选择的补强厚度
            const val = params[`${cur}_thickness`]
            // 选择的补强个数
            const num = params[`${cur}_num`] || '-'
            const valText = val ? `（${val}mm，${num}个/pcs）` : ''
            const curText = isCheck ? `${reinforceType[cur]}${valText}` : ''
            if (curText) prev.push(curText)
            return prev
          }, []).join('、')
        }
      },
      {
        key: 'back_gum_type',
        boardTypes: ['FPC'],
      },
      {
        key: 'electromagnetic_membrane',
        boardTypes: ['FPC'],
      },
      {
        key: 'conducting_resin',
        boardTypes: ['FPC'],
      },
      {
        key: 'countersunk_hole',
        boardTypes: ['ALU', 'COPPER'],
      },
      {
        key: 'overlay_type',
        boardTypes: ['FR-4', 'ROGERS', 'FPC'],
      },
      {
        key: 'impendance',
        boardTypes: ['FR-4', 'ROGERS', 'FPC'],
      },
      {
        key: 'pressing',
        boardTypes: ['FR-4', 'ROGERS'],
        format: (params) => {
          const pressing = params.pressing
          if (pressing.includes('__')) {
            return pressing.split('__')[1]
          }
          return ['无需求', '按客户指定叠层'].includes(pressing) ? pressing : `华秋${pressing}`
        }
      },
      {
        key: 'beveledge',
        boardTypes: ['FR-4', 'ROGERS'],
      },
      {
        key: 'bankong',
        boardTypes: ['FR-4', 'ROGERS'],
      },
      {
        key: 'baobian',
        boardTypes: ['FR-4', 'ROGERS'],
      },
      {
        key: 'press_fit_hole',
        boardTypes: ['FR-4', 'ROGERS'],
      },
      {
        key: 'blue_glue',
        boardTypes: ['ROGERS'],
      },
      {
        key: 'carbon_oil',
        boardTypes: ['ROGERS', 'CEM-1', 'CEM-3', 'FR-1', '22F'],
      },
      {
        key: 'test',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.view_test || (params.test === '样品免费测试' ? '样品免费' : params.test)
        }
      },
    ]
  },
  {
    title: '个性化服务',
    list: [
      {
        key: 'review_file',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'four_terminal',
        boardTypes: ['FR-4'],
      },
      {
        key: 'has_period',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'period_format',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'user_stamp',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F'],
      },
      {
        key: 'cross_board',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'eq_notice',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'engineer_id',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.view_engineer_id || ''
        }
      },
      {
        key: 'lack_handle_type',
        boardTypes: ['FR-4'],
      },
      {
        key: 'insurance_type',
        boardTypes: ['FR-4'],
      },
      {
        key: 'report',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return (params.report || []).join('，')
        }
      },
      {
        key: 'report_type',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'paper',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F'],
      },
      {
        key: 'inner_box_label',
        boardTypes: ['FR-4'],
      },
      {
        key: 'label_remark',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.label_remark || ''
        }
      },
      {
        key: 'hq_pack',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'sh',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'orderman_id',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return `${params.orderman}，${params.ordertel}`
        }
      },
      {
        key: 'note',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.note || ''
        }
      }
    ]
  },
  {
    title: '生产周期',
    list: [
      {
        key: 'deltime',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.standard_deltime || params.deltime || ''
        }
      }
    ]
  }, 
  {
    title: '地址 / 快递',
    list: [
      {
        key: 'fh',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC']
      },
      {
        key: 'fhp',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
      },
      {
        key: 'aid',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.address || ''
        }
      },
      {
        key: 'express',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.view_express || ''
        }
      }
    ]
  }, 
  {
    title: '发票 / 支付',
    list: [
      {
        key: 'invoice',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC']
      },
      {
        key: 'bill_id',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.view_invoice_title || ''
        }
      },
      {
        key: 'invoice_code',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'],
        format: (params) => {
          return params.view_invoice_code || ''
        }
      },
      {
        key: 'deduct_type',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F']
      }
    ]
  }, 
  {
    title: 'SMT贴片',
    list: [
      {
        key: 'is_need_smt',
        boardTypes: ['FR-4', 'ROGERS', 'ALU', 'COPPER', 'CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC']
      }
    ]
  }
]

export const fieldsFormat = (params) => { 
  const board_type = ['CEM-1', 'CEM-3', 'FR-1', '22F'].includes(params.board_type) ? 'CEM-1' : params.board_type
  const types = [...new Set(['FR-4', board_type])]

  // 字段名称：{ [field]: 字段名称 }
  const labels = {
    ...getLabels(types),
    length: params.units == 3 ? '连片尺寸' : '单片尺寸',
    bcount: params.units == 1 ? '单片数量' : '连片数量',
    deltime: '生产周期',
    bill_id: '抬头',
    invoice_code: '税号',
  }

  // 字段单位：{ [field]: 字段单位 }
  const units = getUnitMap(types)

  // 根据字段key获取选项对应的值
  const getValueByKey = key => getOptionsLabel(types, key, params[key])
  // 字段值：{ [field]: 字段值 }
  const valuesByOptions = getKeys(types).reduce((acc, key) => {
    acc[key] = getValueByKey(key)
    return acc
  }, {})
  const values = {
    ...valuesByOptions,
    // PI厚度
    pi_thickness: `${getValueByKey('pi_thickness')} ${units.pi_thickness}`,
    // 最小线宽线距
    lineweight: `${getValueByKey('lineweight')} ${units.lineweight}`,
    // 最小孔径
    vias: `${getValueByKey('vias')} ${units.vias}`,
    // 层压顺序
    overlay_type: `${getValueByKey('overlay_type')}${params.overlay_type == 3 ? '，' + params.overlay_seq : ''}`,
    // 送货单
    fhp: `${getValueByKey('fhp')} ${params.fhp == 1 ? params.fhd_title : ''}`,
  }

  // 字段是否显示
  const isShow = isShowPcbParams(params)
  const getFieldShow = (key) => {
    // 抬头/税号显示条件相同
    if (key === 'invoice_code') {
      return isShow.bill_id
    }
    return isShow[key] === undefined || isShow[key]
  }

  // 字段是否检验通过: { error: true | false, tips: 错误提示语 }
  const validates = validatePcbQuote(params)
  const getFieldValid = (key) => {
    const valid = validates.find(item => {
      // 税号跟抬头是同一个校验
      if (key === 'invoice_code') {
        return item.key === 'bill_id'
      }
      return item.key === key
    })
    if (valid) {
      return { error: valid.flag, tips: valid.tips }
    }
    return { error: false, tips: '' }
  }

  const listFormat = list => {
    return list.reduce((acc, item) => {
      if (!item.boardTypes || item.boardTypes.includes(board_type)) {
        const key = item.key
        /**
         * fieldData: {
         *   label: 字段名称,
         *   value: 字段值,
         *   show: 字段是否显示,
         *   error: 字段检验是否没通过,
         *   tips: 字段检验没通过提示语,
         * }
         */
        const fieldData = {
          ...item,
          label: labels[key],
          value: item.format ? item.format(params) : values[key],
          show: getFieldShow(key),
          ...getFieldValid(key)
        }
        acc.push(fieldData)
      }
      return acc
    }, [])
  }

  const fieldsFormat = FIELDS.reduce((acc, item) => {
    if (!item.boardTypes || item.boardTypes.includes(board_type)) {
      acc.push({ ...item, list: listFormat(item.list) })
    }
    return acc
  }, [])

  return fieldsFormat
}
